module.exports = {

    data(){
        return {
            viewType : false,
            displayDetails: true,
        }
    },

    created(){
        this.viewType = (Storage.get('view-type') != undefined) ? Storage.get('view-type') : false;
        this.displayDetails = (Storage.get('display-details') != undefined) ? Storage.get('display-details') : true;
    },

    mounted(){
        this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip()
        })
    },

    methods: {
        updateShowDetails() {
            this.displayDetails = !this.displayDetails;
            Storage.set('display-details', this.displayDetails);
        }
    }
}
